import React from "react"
import { Box, Typography } from "@mui/material"


export default function lorColumn() {
    return {
        name: "length_of_rental", label: "Length of Rental",
        options: {
            customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                <Typography>{value.join(', ')}</Typography>
            </Box>
        }
    }
}